import { gql } from "@grandvisionhq/graphql";
const eligibleInsurance = gql`
  fragment EligibleInsuranceFragment on EligibleInsurance {
    price {
      subtotal
      net
      gross
    }
    sku
  }
`;
export {
  eligibleInsurance
};
//# sourceMappingURL=eligible-insurance.js.map
